import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Card } from '../../components/chrome';
import LeagueCreateEditForm from './LeagueCreateEditForm';
import { SectionHeader } from '../../components/chrome';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
	toolbarTitle: {
		marginBottom: 15
	}
});

class LeagueEdit extends Component {
	handleAfterSubmit = slug => {
		const { history } = this.props;
	};

	render() {
		const { classes } = this.props;

		return (
			<SectionHeader title="Edit League" backButton={true} backPath={`/leagues/${this.props.match.params.slug}`}>
				<div style={{ marginTop: 24, marginBottom: 24 }}>
					<Grid container justify="center" spacing={24}>
						<Grid item xs={12} md={11} lg={10}>
							<Grid container justify="center" spacing={24}>
								<Grid item xs={12}>
									<Card className={classes.card} elevation={0}>
										<Typography variant="title" color="inherit" className={classes.toolbarTitle}>
											<span>League Details</span>
										</Typography>
										<LeagueCreateEditForm slug={this.props.match.params.slug} />
									</Card>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</SectionHeader>
		);
	}
}

LeagueEdit.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LeagueEdit);
